import {
    Box,
    Button,
    Checkbox,
    Flex,
    FormControl,
    FormHelperText,
    FormLabel,
    HStack,
    Input,
    NumberDecrementStepper,
    NumberIncrementStepper,
    NumberInput,
    NumberInputField,
    NumberInputStepper,
    Select,
    Spacer,
    Stack,
    Text,
} from '@chakra-ui/react';
import { AddIcon, DeleteIcon } from '@chakra-ui/icons';
import usePipelineStore from '../../../../stores/pipeline-store';
import { VarSelect } from '../inputs';

type SurveyLinkStepSettingsProps = {
    stepId: string;
};
export function SurveyLinkStepSettings({ stepId }: SurveyLinkStepSettingsProps) {
    const { pipeline, updateStep } = usePipelineStore((state) => state);
    const step = pipeline.steps[stepId] as unknown as SurveyLinkStepData;

    const updateDataSources = (index: number, param: string, value: any) => {
        let surveyDataSources = JSON.parse(JSON.stringify(step.surveyDataSources));
        surveyDataSources[index][param] = value;
        updateStep(stepId, 'surveyDataSources', surveyDataSources);
    };
    return (
        <Box mx={-3}>
            <FormControl>
                <FormLabel>Survey Name</FormLabel>
                <Input
                    placeholder="Enter survey Id"
                    type="text"
                    bg="white"
                    autoComplete="off"
                    value={step.surveyName ? step.surveyName : ''}
                    onChange={({ target: { value } }: any) => {
                        updateStep(stepId, 'surveyName', value);
                    }}
                />

                <FormLabel mt={2}>Survey Platform</FormLabel>
                <Select
                    color={step.platform == undefined ? 'grey' : 'black'}
                    value={step.platform ? step.platform : ''}
                    backgroundColor="white"
                    onChange={({ target: { value } }: any) => {
                        updateStep(stepId, 'platform', value);
                    }}
                >
                    <option value="" disabled={true}>
                        Select Platform
                    </option>
                    <option value="milgo">Milgo</option>
                    <option value="horizon">Horizon</option>
                </Select>

                <FormLabel mt={2}>Survey Id</FormLabel>
                <Checkbox
                    isChecked={step.surveyIdIsVar}
                    onChange={({ target: { checked } }: any) => {
                        updateStep(stepId, 'surveyIdIsVar', checked);
                    }}
                >
                    Survey Id is a var
                </Checkbox>
                {!step.surveyIdIsVar && (
                    <Input
                        placeholder="Enter survey Id"
                        type="text"
                        bg="white"
                        autoComplete="off"
                        value={step.surveyId ? step.surveyId : ''}
                        onChange={({ target: { value } }: any) => {
                            updateStep(stepId, 'surveyId', value);
                        }}
                    />
                )}
                {step.surveyIdIsVar && (
                    <Box mt={2}>
                        <VarSelect
                            value={step.surveyIdVarId}
                            filterByType={['STRING']}
                            onChange={(value) => updateStep(stepId, 'surveyIdVarId', value)}
                        />
                    </Box>
                )}
            </FormControl>

            <FormControl mt={2}>
                <FormLabel>Answers Limit</FormLabel>
                <Checkbox
                    isChecked={step.answerLimitIsVar}
                    onChange={({ target: { checked } }: any) => {
                        updateStep(stepId, 'answerLimitIsVar', checked);
                    }}
                >
                    Answers limit is a var
                </Checkbox>

                {!step.answerLimitIsVar && (
                    <>
                        <NumberInput
                            mt={2}
                            bg="white"
                            min={0}
                            value={step.answerLimit ? step.answerLimit : 0}
                            onChange={(value: any) => {
                                updateStep(stepId, 'answerLimit', parseInt(value));
                            }}
                        >
                            <NumberInputField />
                            <NumberInputStepper>
                                <NumberIncrementStepper />
                                <NumberDecrementStepper />
                            </NumberInputStepper>
                        </NumberInput>
                        <FormHelperText>{'Set 0 for unlimited'}</FormHelperText>
                    </>
                )}

                {step.answerLimitIsVar && (
                    <Box mt={2}>
                        <VarSelect
                            value={step.answerLimitVarId}
                            filterByType={['NUMBER']}
                            onChange={(value) => updateStep(stepId, 'answerLimitVarId', value)}
                        />
                    </Box>
                )}
            </FormControl>
            <FormControl mt={2}>
                <FormLabel>Url target var</FormLabel>
                <VarSelect
                    value={step.urlTargetVarId}
                    filterByType={['STRING']}
                    onChange={(value) => updateStep(stepId, 'urlTargetVarId', value)}
                />
            </FormControl>

            <FormControl mt={2}>
                <FormLabel>Survey Ref target var</FormLabel>
                <VarSelect
                    value={step.surveyRefTargetVarId}
                    filterByType={['REF']}
                    onChange={(value) => updateStep(stepId, 'surveyRefTargetVarId', value)}
                />
            </FormControl>

            <FormControl mt={2}>
                <FormLabel>Responses count var</FormLabel>
                <VarSelect
                    value={step.responsesCounterTargetVarId}
                    filterByType={['NUMBER']}
                    onChange={(value) => updateStep(stepId, 'responsesCounterTargetVarId', value)}
                />
            </FormControl>

            <FormControl mt={2}>
                <FormLabel>Survey Params</FormLabel>
                <Stack>
                    {step.surveyParams?.map((paramElem, index) => {
                        return (
                            <Flex key={index}>
                                <Button
                                    backgroundColor="white"
                                    _hover={{ color: '#f0706e' }}
                                    _focus={{ backgroundColor: 'white' }}
                                    _active={{ backgroundColor: 'white' }}
                                    color={'grey'}
                                    leftIcon={<DeleteIcon />}
                                    //

                                    onClick={() => {
                                        let surveyParams = JSON.parse(JSON.stringify(step.surveyParams));
                                        surveyParams.splice(index, 1);
                                        updateStep(stepId, 'surveyParams', surveyParams);
                                    }}
                                ></Button>
                                <Input
                                    backgroundColor="white"
                                    placeholder="key"
                                    focusBorderColor={'white'}
                                    value={paramElem.key}
                                    onChange={({ target: { value } }: any) => {
                                        let surveyParams = JSON.parse(JSON.stringify(step.surveyParams));
                                        surveyParams[index].key = value;
                                        updateStep(stepId, 'surveyParams', surveyParams);
                                    }}
                                />
                                <Spacer minW={1} />
                                <VarSelect
                                    value={paramElem.valueVarId}
                                    filterByType={['STRING', 'NUMBER', 'BOOLEAN', 'REF']}
                                    onChange={(value) => {
                                        const surveyParams = JSON.parse(JSON.stringify(step.surveyParams));
                                        surveyParams[index].valueVarId = value;
                                        updateStep(stepId, 'surveyParams', surveyParams);
                                    }}
                                />
                            </Flex>
                        );
                    })}

                    <Button
                        backgroundColor="white"
                        fontSize={'sm'}
                        _hover={{ backgroundColor: 'white', color: 'black' }}
                        _focus={{ backgroundColor: 'white' }}
                        _active={{ backgroundColor: 'white' }}
                        color={'grey'}
                        leftIcon={<AddIcon />}
                        onClick={() => {
                            let surveyParams = JSON.parse(JSON.stringify(step.surveyParams));

                            surveyParams.push({
                                key: '',
                                valueVarId: '',
                            });

                            updateStep(stepId, 'surveyParams', surveyParams);
                        }}
                    >
                        Add param
                    </Button>
                </Stack>
            </FormControl>

            <FormControl mt={2}>
                <FormLabel>Survey Datasources</FormLabel>
                <Stack>
                    {step.surveyDataSources?.map((dataSource, index) => {
                        return (
                            <Box borderWidth="1px" borderRadius="md" padding={2} key={index} position="relative" mb={2}>
                                <Button
                                    backgroundColor="white"
                                    _hover={{ color: '#f0706e' }}
                                    _focus={{ backgroundColor: 'white' }}
                                    _active={{ backgroundColor: 'white' }}
                                    color={'grey'}
                                    leftIcon={<DeleteIcon />}
                                    position="absolute"
                                    top={'0px'}
                                    left={'0px'}
                                    zIndex={10}
                                    padding={'0 !important'}
                                    onClick={() => {
                                        let surveyDataSources = JSON.parse(JSON.stringify(step.surveyDataSources));
                                        surveyDataSources.splice(index, 1);
                                        updateStep(stepId, 'surveyDataSources', surveyDataSources);
                                    }}
                                ></Button>
                                <Flex mt={2}>
                                    <Input
                                        type="text"
                                        me={2}
                                        mt={4}
                                        ms={8}
                                        bg="white"
                                        autoComplete="off"
                                        w={'100%'}
                                        placeholder={'Datasource name'}
                                        value={dataSource.name}
                                        onChange={(e) => updateDataSources(index, 'name', e.target.value)}
                                    />
                                    <Select
                                        mt={4}
                                        color={'black'}
                                        w={'100%'}
                                        value={dataSource.type}
                                        backgroundColor="white"
                                        onChange={({ target: { value } }: any) => {
                                            updateDataSources(index, 'type', value);
                                        }}
                                    >
                                        <option value="json string">JSON string</option>
                                        <option value="record">Record</option>
                                        <option value="json">JSON</option>
                                    </Select>
                                </Flex>
                                {dataSource.type === 'json string' ? (
                                    <Box mt={2} ms={8}>
                                        <VarSelect
                                            value={dataSource.varId}
                                            filterByType={['STRING', 'REF']}
                                            onChange={(value) => updateDataSources(index, 'varId', value)}
                                        />
                                    </Box>
                                ) : dataSource.type === 'record' ? (
                                    <Stack ms={8}>
                                        <Box mt={2}>
                                            <VarSelect
                                                value={dataSource.recordData?.surveyRefVarId ?? ''}
                                                filterByType={['REF']}
                                                onChange={(value) => {
                                                    const recordData = { ...dataSource.recordData };
                                                    recordData.surveyRefVarId = value;
                                                    updateDataSources(index, 'recordData', recordData);
                                                }}
                                            />
                                        </Box>
                                        <Flex mt={4}>
                                            <Text w={'130px'} mt={2}>
                                                Record Index:
                                            </Text>
                                            <Input
                                                type="number"
                                                bg="white"
                                                value={dataSource.recordData?.recordIndex}
                                                onChange={({ target: { value } }: any) => {
                                                    let recordData = { ...dataSource.recordData };
                                                    recordData.recordIndex = parseInt(value);
                                                    updateDataSources(index, 'recordData', recordData);
                                                }}
                                            />
                                        </Flex>
                                    </Stack>
                                ) : (
                                    <Stack ms={8}>
                                        {dataSource.jsonData?.map(({ itemName, varId }, varIdIndex) => {
                                            return (
                                                <Flex mt={2} key={varId}>
                                                    <Button
                                                        backgroundColor="white"
                                                        _hover={{ color: '#f0706e' }}
                                                        _focus={{ backgroundColor: 'white' }}
                                                        _active={{ backgroundColor: 'white' }}
                                                        color={'grey'}
                                                        leftIcon={<DeleteIcon />}
                                                        padding={'0 !important'}
                                                        onClick={() => {
                                                            let jsonData = JSON.parse(
                                                                JSON.stringify(dataSource.jsonData),
                                                            );
                                                            jsonData = [
                                                                ...jsonData.slice(0, varIdIndex),
                                                                ...jsonData.slice(varIdIndex + 1),
                                                            ];
                                                            if (process.env.NODE_ENV === 'development') {
                                                                console.log(jsonData);
                                                            }
                                                            updateDataSources(index, 'jsonData', jsonData);
                                                        }}
                                                    />
                                                    <Input
                                                        type="text"
                                                        bg="white"
                                                        autoComplete="off"
                                                        w={'100%'}
                                                        me={2}
                                                        placeholder={'Item name'}
                                                        value={itemName}
                                                        onChange={({ target: { value } }: any) => {
                                                            let jsonData = JSON.parse(
                                                                JSON.stringify(dataSource.jsonData),
                                                            );
                                                            jsonData[varIdIndex].itemName = value;
                                                            updateDataSources(index, 'jsonData', jsonData);
                                                        }}
                                                    />
                                                    <VarSelect
                                                        width="100%"
                                                        value={varId}
                                                        onChange={(value) => {
                                                            const jsonData = JSON.parse(
                                                                JSON.stringify(dataSource.jsonData),
                                                            );
                                                            jsonData[varIdIndex].varId = value;
                                                            updateDataSources(index, 'jsonData', jsonData);
                                                        }}
                                                    />
                                                </Flex>
                                            );
                                        })}
                                        <Button
                                            backgroundColor="white"
                                            _hover={{ backgroundColor: 'white', color: 'black' }}
                                            _focus={{ backgroundColor: 'white' }}
                                            _active={{ backgroundColor: 'white' }}
                                            color={'grey'}
                                            leftIcon={<AddIcon />}
                                            onClick={() => {
                                                let jsonData = [];
                                                if (dataSource.jsonData) {
                                                    jsonData = JSON.parse(JSON.stringify(dataSource.jsonData));
                                                }
                                                jsonData.push({
                                                    itemName: '',
                                                    varId: '',
                                                });
                                                updateDataSources(index, 'jsonData', jsonData);
                                            }}
                                        >
                                            Add var
                                        </Button>
                                    </Stack>
                                )}
                                <HStack pl={8} pb={4} width={'100%'} mt={4}>
                                    <Text mb={1} w={'230px'}>
                                        Disable data source var:
                                    </Text>
                                    <VarSelect
                                        width="100%"
                                        value={dataSource.dataSourceDisabledVar ?? ''}
                                        filterByType={['BOOLEAN']}
                                        onChange={(value) => updateDataSources(index, 'dataSourceDisabledVar', value)}
                                    />
                                </HStack>
                            </Box>
                        );
                    })}

                    <Button
                        backgroundColor="white"
                        fontSize={'sm'}
                        _hover={{ backgroundColor: 'white', color: 'black' }}
                        _focus={{ backgroundColor: 'white' }}
                        _active={{ backgroundColor: 'white' }}
                        color={'grey'}
                        leftIcon={<AddIcon />}
                        onClick={() => {
                            let surveyDataSources: SurveyDataSource[] = [];
                            if (step.surveyDataSources) {
                                surveyDataSources = JSON.parse(JSON.stringify(step.surveyDataSources));
                            }

                            surveyDataSources.push({
                                name: '',
                                varId: '',
                                type: 'json string',
                                recordData: {
                                    surveyRefVarId: '',
                                    recordIndex: 0,
                                },
                                jsonData: [],
                                dataSourceDisabledVar: '',
                            });

                            updateStep(stepId, 'surveyDataSources', surveyDataSources);
                        }}
                    >
                        Add datasource
                    </Button>
                </Stack>
            </FormControl>
        </Box>
    );
}
